import { Axios } from '@src/app/context/Api/includes/Axios';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';

/**
 * RefreshEIMP
 *
 * Refresh EIMP data by putting the EID onto the stream for re-processing
 *
 * @param payload
 * @returns {Promise<any>}
 * @constructor
 */
export const RefreshEIMP = async (payload = {}) => {
  try {
    const theApiKey = payload?.[0];
    const theMutationKey = payload?.[1];
    const thePayload = payload?.[2];

    const requestArgs = {
      baseURL: config('API_URL'),
      data: {},
      headers: {
        'x-api-endpoint': `/eimp/${thePayload?.eid}/refresh`,
      },
      method: 'PUT',
      params: { apiKey: theApiKey, mutationKey: theMutationKey },
    };

    const remoteResponse = await Axios.request(requestArgs);

    return remoteResponse.data;
  } catch (error) {
    logger.error('src/entities/RiskRecord/api/requests/mutations/RefreshEIMP.js -> RefreshEIMP()', false, error);

    throw error;
  }
};
